<p-table
  dataKey="name"
  [value]="tools"
  [(selection)]="selectedTools"
  [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th style="width: 1rem"></th>
      <th>Tool</th>
      <th>Read / Write</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-tool let-rowIndex="rowIndex">
    <tr [pSelectableRow]="tool" [pSelectableRowIndex]="rowIndex">
      <td>
        <p-tableCheckbox [value]="tool"></p-tableCheckbox>
      </td>
      <td><i [class]="tool.icon"></i></td>
      <td>{{ tool.name }}</td>
      <td>
        <p-inputSwitch
          [disabled]="!selectedTools.includes(tool)"
          (click)="accessToggle()"></p-inputSwitch>
      </td>
    </tr>
  </ng-template>
</p-table>
